module.exports = __webpack_public_path__ + "static/elm-acc-app.1562e76d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/elm-acc-app.png
// module id = 103
// module chunks = 17199820305509 35783957827783